import { useEffect, useState, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import { VolunteerMeta } from '../../components';
import utils from '../../utils';
import {
  ALL,
  ASSIGN,
  COUNCIL,
  departments,
  OLD_QUESTIONNAIRE_SAMPLE,
  UNASSIGN,
} from '../../constants/volunteers';
import { setVolunteers } from '../../store/reducers/volunteersService';
import { VOLUNTEERS_ENDPOINT, SERVER_HOST } from '../../constants/endpoints';

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const defineTabId = (tabIndex) => {
  switch (tabIndex) {
    case 1:
      return UNASSIGN;
    case 2:
      return ASSIGN;
    case 3:
      return COUNCIL;
    case 0:
    default:
      return ALL;
  }
};

const useSimpleTabs = (searchValue, setPagesTotal, pageNumber) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);
  const [volunteersTotal, setVolunteersTotal] = useState(0);
  const { volunteers } = useSelector((state) => state?.volunteersService);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      await fetch(
        SERVER_HOST +
          VOLUNTEERS_ENDPOINT +
          `/?pageNumber=${pageNumber}` +
          `&tabId=${defineTabId(tabIndex)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            searchQuery: searchValue || '',
          }),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            /**
             * TODO: Rewrite this realization to minimize calling alerts
             */
            // alert(
            //   'Произошла ошибка. Пожалуйста, отправьте следующий ' +
            //     'текст ошибки администратору сайта на it@gold-race.org: ' +
            //     `ERROR ${response.status}: ${response.statusText}`
            // );
          }
        })
        .then((result) => {
          const { volunteers, volunteersTotal, pagesTotal } = result;

          dispatch(setVolunteers({ volunteers }));
          setVolunteersTotal(volunteersTotal);
          setPagesTotal(pagesTotal);
        })
        .catch(() => {
          /**
           * TODO: Rewrite this realization to minimize calling alerts
           */
          // return alert(
          //   'Произошла ошибка. Пожалуйста, отправьте следующий ' +
          //     'текст ошибки администратору сайта на it@gold-race.org: ' +
          //     errorText
          // )
        })
        .finally(() => {
          setLoading(false);
        });
    };

    fetchData();
  }, [pageNumber, tabIndex, searchValue]);

  const handleChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
    },
    [setTabIndex]
  );

  const memoizedAllVolunteers = useMemo(() => {
    return volunteers.map((item) => (
      <Box key={utils.addID()} mb={2}>
        <VolunteerMeta
          key={utils.addID()}
          fullName={`${item.lastName?.toUpperCase()} ${item.firstName} ${
            item.middleName !== OLD_QUESTIONNAIRE_SAMPLE ? item.middleName : ''
          }`}
          education={item.education}
          profession={item.profession}
          hobby={item.hobby}
          year={item?.year}
          id={item.id}
          department={
            (item.serviceInfo &&
              item.serviceInfo.department &&
              departments.filter(
                (item_) => item_.id === item.serviceInfo.department
              )[0]?.label) ||
            null
          }
          item={item}
        />
      </Box>
    ));
  }, [volunteers]);

  return {
    classes,
    isLoading,
    tabIndex,
    volunteers,
    volunteersTotal,
    memoizedAllVolunteers,
    a11yProps,
    handleChange,
  };
};

export default useSimpleTabs;
